module.exports = __webpack_public_path__ + "media/images/psp/star-alliance-white-19ca6f5a55f8fda5b01e7609d9fc5277.svg";